import { composeStateMachine } from '@opengov/compose-app/core/module';
import { List, Map } from 'immutable';
import { EGranteeType, IGrantee, IInvitableUser } from '@opengov/reporting-types';

import { DataTableStatus } from '../../types';
import { ReportAccessTableRecord } from '../records/records';

export const reportAccessTableState = composeStateMachine(
  'report-access-table',
  ReportAccessTableRecord(),
  (compose) => ({
    setAccessTableStatus: compose.action((state, status: DataTableStatus) => state.set('accessTableStatus', status)),
    setCurrentGrantees: compose.action((state, payload: { grantees: Map<string, IGrantee> }) =>
      state.set('currentGrantees', payload.grantees)
    ),
    updateCurrentGrantees: compose.action((state, payload: { grantees: Map<string, IGrantee> }) =>
      state.set('currentGrantees', payload.grantees)
    ),
    setTemporaryGrantees: compose.action((state, payload: { grantees: Map<string, IGrantee> }) =>
      state.set('temporaryGrantees', payload.grantees)
    ),
    updateTemporaryGrantee: compose.action((state, payload: IGrantee) => {
      const existingGrantee = state.temporaryGrantees.get(payload.granteeId);

      // we currently do not support removing groups
      if (existingGrantee && existingGrantee.granteeType !== EGranteeType.Group && payload.actionSet === 'none') {
        return state.set('temporaryGrantees', state.temporaryGrantees.delete(payload.granteeId));
      }
      return state.set('temporaryGrantees', state.temporaryGrantees.set(payload.granteeId, payload));
    }),
    setInvitableUsers: compose.action((state, payload: { grantees: List<IInvitableUser> }) =>
      state.set('invitableUsers', payload.grantees)
    )
  })
);

export const {
  actions: accessTableActons,
  actionCreators: accessTableActionCreators,
  reducer: accessTableReducer,
  selector: accessTableSelector
} = reportAccessTableState;
